import React from "react";
import { connect } from "react-redux";
import {
  Row,
  Col,
} from "react-bootstrap";
import { StyleSheet, css } from "aphrodite";
import moment from "moment-timezone";

const Footer = () => {
    return (
            <div className={css(styles.footer)}>
                <Row style={{ display: "flex", margin: "0px", alignItems: "center" }}>
                    <Col>
                        ©Copyright {moment().format("YYYY")} <b>SMART MONITOR CORP.</b>{" "}
                        All Rights Reserved
                    </Col>
                    <Col style={{ display: "flex", alignItems: "center", justifyContent: "flex-end" }}>
                        <span className={css(styles.textRight)}>Powered By</span>
                        <img
                            src="/images/acuma_logo.png"
                            alt="acuma"
                            className={css(styles.footerLogo)}
                        />
                    </Col>
                </Row>
            </div>
    );
};

export default Footer;

const styles = StyleSheet.create({
  footer: {
    backgroundColor: "#ffffff",
    boxShadow: "0px -2px 7px -2px rgba(189, 182, 189, 1)",
    padding: "7px 0px 3px",
    color: "#5d5d5d",
    //position:'fixed',
    bottom: "0",
    //width: "101%",
    fontSize: "14px"
  },
  textRight: {
    marginRight: "-20px",
    paddingTop: "10px",
    fontStyle: "italic",
  },
  footerLogo: {
    width: "200px",
    height: "40px",
    //marginTop: "-10px",
    //marginLeft: "14px",
  },
});